<template>
    <div class="col-lg-6 col-md-6 col-sm-12">
        <a :href="link" target="_blank">
            <div class="certificate">
                <div class="certificate__icon">
                    <span class="fa-stack fa-2x">
                        <i class="fas fa-circle fa-stack-2x"></i>
                        <i class="fal fa-file-certificate fa-stack-1x fa-inverse"></i>
                    </span>
                </div>
                <div class="certificate__title">
                    {{ title }}
                </div>
                <div class="certificate__issuer">
                    {{ issuer }}
                </div>
            </div>
        </a>
    </div>
</template>

<style lang="scss" scoped>
.certificate {
    background: #fff;
    padding: 30px;
    border: 1px solid rgba(0, 0, 0, .07);
    box-shadow: 0 15px 35px rgba(50,50,93,.1), 0 5px 15px rgba(0,0,0,.07);
    text-align: center;
    transition: 0.3s ease all;
    border-radius: 4px;
    margin-bottom: 20px;

    &:hover {
        /* background: #8b0000;
        color: #fff; */
        cursor: pointer;
        transform: translateY(-4px);
    }

    &__icon {
        margin-bottom: 1em;

        .fa-circle {
            color: #8b0000;
        }
        
    }

    &__title {
        font-size: 1em;
        font-weight: bold;
    }

    &__issuer {

    }
}
</style>


<script>
export default {
    props: {
        title: {
            required: true,
            type: String
        },
        issuer: {
            required: true,
            type: String
        },
        link: {
            required: true,
            type: String
        }
    }
}
</script>




// WEBPACK FOOTER //
// certificate.vue?5aec6556